// project import
import dashboard from './dashboard';
import userManagement from './user-management';
import reports from './reports';

// types
import { NavItemType } from 'types';

// ==============================|| SUPER ADMIN MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
    items: [dashboard, userManagement, reports]
};

export default menuItems;

